import React from 'react'
import { Link } from '@mui/material';
import CustomdecalsImage from '../Images/Customdecals.webp';
import DecorateConcaveImage from '../Images/DecorateConcave.webp'
import HighFiringImage from '../Images/HighFiring.webp';
import ColdPrintingImage from '../Images/ColdPrinting.webp';
import ThermalDecalPrintingwowImage from '../Images/ThermalDecalPrintingwow.webp'

const ThermalDecalPrinting = () => {
  return (
    <>
<article className='pt-8 max-w-[1200px] mx-auto px-8'>
  <title>Thermal Decal Printing</title>
       
       
       <section class="mb-8 ">
         <h1 className='text-2xl font-bold pb-4'>Thermal Decal Printing</h1>
        <div className=''><img src={CustomdecalsImage} alt='' title='' className='lg:w-3/12 lg:float-left my-8 mb-8'/></div>
       
          
<div><h2 class="text-xl font-semibold mb-2">What Are Decals?</h2></div>
<div>
    <p class="pb-8">
    Decals—also known as transfer or indirect printing—are a widely used industrial method for applying consistent decoration to ceramic, glass, and other surfaces. This technique dates back to the 18th century and was first industrialized by Wedgwood in Stoke-on-Trent, UK, with their now-famous “creamware.”
  </p>


  <h2 class="text-xl font-semibold mb-4">Applications in Industry</h2>
  <p class="">
    Decals are ideal for decorating, identifying, or branding products in sectors like tableware, tiles, lighting, sanitaryware, promotional goods, and insulators. Common applications include commemorative plates, branded dish sets, or decorative donor tiles.
  </p>
  <p class=" mt-2">
    Our custom decals can reproduce nearly any image: logos, photos, illustrations, paintings, posters—even signatures. They can be applied to both regular and complex shapes where direct printing is not feasible.
  </p>
</div>
</section>



<section className="mb-8 clear-both ">
  <div className=''><img src={DecorateConcaveImage} alt='' title='' className='lg:w-4/12 lg:float-right lg:mr-8'/></div>
  <h2 className="text-xl font-semibold">Why Choose Decals?</h2>



  <ul class="list-disc list-inside lg:pt-8">
    <li>Decorate concave, convex, and irregular surfaces</li>
    <li>Achieve vibrant and accurate color reproduction</li>
    <li>Use multiple colors with precision and consistency</li>
  </ul>
  <p className="mt-4">
    We offer both <strong>water-based decals</strong> for manual application (ideal for medium to large runs) and <strong>thermal decals</strong> for heat transfer.
  </p>
</section>

<section class="mb-8 ">



  <h2 class="text-xl font-semibold mb-4 clear-both">Firing Temperatures & Best Practices</h2>
    <p class="">
    Firing temperatures are general guidelines. Always test your decals on your specific materials and firing equipment before beginning full production.
  </p>
  <div className='lg:float-left lg:w-3/12 lg:px-10'><img src={ColdPrintingImage} alt='' title='' className=''/></div>


  <div class="mt-4">
    
    <h3 class="font-semibold mb-4">Cold Printing (80-220°C / 150-500°F)</h3>
<p >Ideal for decorative and advertising applications on candles, glass windows, bottles, porcelain, pottery, doors, tables, crystal ornaments, glass ornaments, glass panels, electrical appliances, sports equipment, and many other products. It is also suitable for positive and reverse water-based labels. Screen printing is performed using LED/UV ink or solvent-based ink, providing excellent printing performance.</p>  

<p className='py-4'>Cured by LED/UV technology, it features fast drying speed, environmental friendliness, energy saving, little or no odor, high flexibility, and odorless. The product has effective stability after baking, excellent adhesion, good water resistance, and excellent wine-soaking performance. It can be used without heat, at room temperature and left for 24 hours or longer, or dried with a hair dryer to speed up the drying process.</p>
  </div>

  <div class="p-8 clear-both bg-[#FDD26E] ">
    <div className='lg:float-right lg:w-2/12'><img src={HighFiringImage} alt='' title='' className=''/></div>  
    <h3 class="font-semibold mb-4">Low Firing Decal (520-580°C / 968-1076°F)</h3>
    <p class="">Recommended for glassware and similar substrates. Typical cone range: 022-021.</p>

      
    <h3 class="font-semibold my-4">High Firing Decal (735-850°C / 1360-1562°F)</h3>
    <p class="">For ceramic and porcelain pieces that come into contact with food. Cone range: 017.</p>

      <p class="mt-4">
    Maintain peak temperature for 20-30 minutes. Ensure the kiln is vented until 750°C, then close it fully and allow the soak cycle. Cool slowly over 6–8 hours for best results.
  </p>
  </div>





    <h2 className="text-xl font-semibold mb-4 mt-8">Important Usage Notes</h2>
  <ul class="list-disc list-inside ">
    <li>We are not responsible for firing-related damages or misapplications.</li>
    <li>We do not guarantee lead or cadmium compliance unless otherwise specified.</li>
    <li>Do not apply decals to food-contact surfaces unless they are properly glazed and tested.</li>
    <li>Always consult local safety and compliance regulations for your market.</li>
  </ul>
</section>




    </article>


<section className='my-8'><img src={ThermalDecalPrintingwowImage} alt='' title=''/></section>



<section className='pt-8 max-w-[1200px] mx-auto px-8'>
  <h2 class="text-xl font-semibold mb-2">Need Help?</h2>
  <p class="">
    Have questions or need support for your specific production setup? <Link href="/Contact" style={{color: '#C13E39'}}>Contact us</Link> directly or send us an email at <Link href="mailto:gotenbergnawas@gmail.com" style={{color: '#C13E39'}}>gotenbergnawas@gmail.com</Link>. We're happy to assist with testing, material compatibility, and bulk ordering.
  </p>
</section>




      <section className='my-8 border-2 border-[#6C969D] bg-white shadow-lg rounded-xl p-4 pt-8 max-w-[1200px] mx-auto px-8'>
        <h4 className='text-xl py-4 font-bold'>Ordering Custom Decals</h4>
        <p className='py-4'>Please note that our standard turnaround time for custom decals is 10-15 business days, excluding weekends and holidays. Orders are processed in the order they are received, and there may be a few ahead of yours in the queue.</p>
        <p>If you require expedited production, a <span>rush fee of 50%</span> of your total order will be added to the invoice.</p>
      </section>

    </>
  )
}

export default ThermalDecalPrinting
